import React, { useMemo } from "react";
import ReportsLookerPage from "../components/ReportsLookerPage";
import { LOOKER_CHARTS } from "../constants";
import { PathToPurchase } from "../components/PathToPurchase";
import { useFlags } from "launchdarkly-react-client-sdk";
import { EmbedLookerChart } from "@components/EmbedLookerChart";
import ReportsSankey from "./ReportsSankey";
import { Box } from "@mui/material";

const ReportsPathToPurchase = ({
  inExplore,
  setInExplore,
  internal,
  active
}: {
  inExplore: boolean,
  setInExplore: React.Dispatch<React.SetStateAction<boolean>>,
  internal?: boolean
  active?: boolean
}) => {
  const { newPathToPurchase } = useFlags();

  const tabs = useMemo(() => {
    if (!newPathToPurchase) return {
      id: LOOKER_CHARTS.PATH_TO_PURCHASE.id,
      title: LOOKER_CHARTS.PATH_TO_PURCHASE.title,
      content: () => (
        <PathToPurchase
          setInExplore={setInExplore}
          internal={internal}
        />
      )
    }
    return [
      {
        id: LOOKER_CHARTS.P2P_FREQUENCY.id,
        title: LOOKER_CHARTS.P2P_FREQUENCY.title,
        content: () => <EmbedLookerChart
          id={LOOKER_CHARTS.P2P_FREQUENCY.id}
          dashboard={LOOKER_CHARTS.P2P_FREQUENCY.dashboardName}
          setInExplore={setInExplore}
          internal={internal}
        />
      },
      {
        id: LOOKER_CHARTS.P2P_ORDER_LIST.id,
        title: LOOKER_CHARTS.P2P_ORDER_LIST.title,
        content: () => <EmbedLookerChart
          id={LOOKER_CHARTS.P2P_ORDER_LIST.id}
          dashboard={LOOKER_CHARTS.P2P_ORDER_LIST.dashboardName}
          setInExplore={setInExplore}
          internal={internal}
        />
      },
      {
        id: 'referral-flow',
        title: 'Referral Flow',
        content: () => (
          <Box marginTop="24px">
            <ReportsSankey />
          </Box>
        )
      },
      {
        id: LOOKER_CHARTS.P2P_CUSTOMER_JOURNEY.id,
        title: LOOKER_CHARTS.P2P_CUSTOMER_JOURNEY.title,
        content: () => <EmbedLookerChart
          id={LOOKER_CHARTS.P2P_CUSTOMER_JOURNEY.id}
          dashboard={LOOKER_CHARTS.P2P_CUSTOMER_JOURNEY.dashboardName}
          setInExplore={setInExplore}
          internal={internal}
        />
      }
    ]
  }, [newPathToPurchase])

  return (
    <ReportsLookerPage
      tabs={tabs}
      setInExplore={setInExplore}
      inExplore={inExplore}
      active={active}
    />);
}

export default ReportsPathToPurchase;
